import { render, staticRenderFns } from "./ExampleDialog.vue?vue&type=template&id=520f7387&scoped=true"
import script from "./ExampleDialog.vue?vue&type=script&lang=ts"
export * from "./ExampleDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExampleDialog.vue?vue&type=style&index=0&id=520f7387&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f7387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520f7387')) {
      api.createRecord('520f7387', component.options)
    } else {
      api.reload('520f7387', component.options)
    }
    module.hot.accept("./ExampleDialog.vue?vue&type=template&id=520f7387&scoped=true", function () {
      api.rerender('520f7387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ExampleDialog.vue"
export default component.exports